/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useContext } from 'react';
import { Button } from 'components';
import { Button as ButtonV2 } from '@bb/elements-web';
import styled from 'styled-components';
import { LayoutContext } from 'contexts';

const ActionBar: React.FC<{
  visible?: boolean;
  floating?: boolean;
  onReset?: () => void;
  onSave?: () => void;
}> = ({ visible = true, floating = false, onReset, onSave }) => {
  const { getSiderCurrentWidth, chatVisibility, footerHeight } =
    useContext(LayoutContext);

  if (!visible) return null;

  const CONTENT = (
    <FlexContainer $floating={floating} $chatVisibility={chatVisibility}>
      <StyledSpan>You have unsaved changes!</StyledSpan>
      <ButtonContainer>
        <Button type="text" onClick={onReset}>
          Reset
        </Button>
        <ButtonV2
          onClick={onSave}
          dataCy="save-changes-button"
          size="small"
          styleOverride={{ minWidth: '70px' }}
        >
          Save
        </ButtonV2>
      </ButtonContainer>
    </FlexContainer>
  );

  if (floating) {
    return (
      <FixedDiv
        $marginLeft={getSiderCurrentWidth()}
        $marginBottom={footerHeight}
        $chatVisibility={chatVisibility}
      >
        {CONTENT}
      </FixedDiv>
    );
  }

  return CONTENT;
};

const MARGIN_HORIZONTAL = 16;
const CHAT_FLOAT_MARGIN = 92;

const FixedDiv = styled.div<{
  $marginLeft: number;
  $marginBottom: number;
  $chatVisibility: boolean;
}>`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  margin-left: ${({ $marginLeft }) => $marginLeft + MARGIN_HORIZONTAL}px;
  margin-right: ${({ $chatVisibility }) =>
    ($chatVisibility ? CHAT_FLOAT_MARGIN : 0) + MARGIN_HORIZONTAL}px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;

  border: 1px solid #f0f0f0;
  border-radius: 4px;
  box-shadow:
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px rgba(0, 0, 0, 0.08),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

const FlexContainer = styled.div<{
  $floating: boolean;
  $chatVisibility: boolean;
}>`
  background: white;
  padding: 16px;
  margin-left: ${({ $floating }) => (!$floating ? 16 : 0)}px;
  margin-right: ${({ $floating }) => (!$floating ? 16 : 0)}px;
  margin-bottom: ${({ $floating, $chatVisibility }) =>
    !$floating && $chatVisibility ? 92 : 0}px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-self: ${({ $floating }) => (!$floating ? 'end' : 'unset')};
  align-items: center;
  justify-content: space-between;
`;

const StyledSpan = styled.span`
  margin-right: 16px;
  max-width: calc(100% - 142px);
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export default ActionBar;
